var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "btn-group btn-group-toggle" }, [
    _c(
      "label",
      {
        staticClass: "month-option py-md-3 px-md-4 btn btn-outline-secondary",
        class: { active: _vm.groupOptions === _vm.orderGroups.one }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.groupOptions,
              expression: "groupOptions"
            }
          ],
          staticClass: "text-uppercase",
          attrs: { checked: "", id: "option1", type: "radio" },
          domProps: {
            value: _vm.orderGroups.one,
            checked: _vm._q(_vm.groupOptions, _vm.orderGroups.one)
          },
          on: {
            change: function($event) {
              _vm.groupOptions = _vm.orderGroups.one
            }
          }
        }),
        _vm._v(" 3 Livros\n    ")
      ]
    ),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "month-option py-md-3 px-md-4 btn btn-outline-secondary",
        class: { active: _vm.groupOptions === _vm.orderGroups.two }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.groupOptions,
              expression: "groupOptions"
            }
          ],
          staticClass: "text-uppercase",
          attrs: { id: "option2", type: "radio" },
          domProps: {
            value: _vm.orderGroups.two,
            checked: _vm._q(_vm.groupOptions, _vm.orderGroups.two)
          },
          on: {
            change: function($event) {
              _vm.groupOptions = _vm.orderGroups.two
            }
          }
        }),
        _vm._v(" 4 Livros\n    ")
      ]
    ),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "month-option py-md-3 px-md-4 btn btn-outline-secondary",
        class: { active: _vm.groupOptions === _vm.orderGroups.three }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.groupOptions,
              expression: "groupOptions"
            }
          ],
          staticClass: "text-uppercase",
          attrs: { id: "option3", type: "radio" },
          domProps: {
            value: _vm.orderGroups.three,
            checked: _vm._q(_vm.groupOptions, _vm.orderGroups.three)
          },
          on: {
            change: function($event) {
              _vm.groupOptions = _vm.orderGroups.three
            }
          }
        }),
        _vm._v(" 6 Livros\n    ")
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/simon/code/ataba-wordpress-site/web/app/themes/rits/node_modules/vue-loader/lib?{}!./scripts/vue/template-school/choose-plan-school/ChooseOrderGroup.vue?vue&type=template&id=d21f9aae&
// module id = 444
// module chunks = 1